import { Component } from 'react';
import AuthorSettings from '../../AuthorSettings';
import { withTranslation } from 'react-i18next';

class AuthorReports extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="padding-x-20">
                    <div id="onboarding-general-settings" className="onboard-checkbox-inputs">
                        <AuthorSettings csrf_token={this.props.csrf_token} fromOnboard />
                    </div>
                </div>
                <div className="onboarding-container-item-body-footer">
                    <button
                        className="onboarding-skip-btn"
                        style={{ lineHeight: 'unset' }}
                        onClick={() => this.props.handleBack()}
                    >
                        {t('onboarding.back')}
                    </button>
                    <button className="onboarding-btn-next" onClick={() => this.props.handleNext()}>
                        {t('onboarding.skip')}
                    </button>
                </div>
            </>
        );
    }
}

export default withTranslation()(AuthorReports);
